<template>
  <main>
    <PageIntro
      :heading="'Your <span>' +configStrings.productName + '</span> account'"
      :body="'<p>Please check your email for your verification code and follow the simple instructions below to reset your password.</p>'" />
    <ResetPasswordForm />
    <FooterShout :type="'signin'"/>
  </main>
</template>

<script>
  import ResetPasswordForm from '@/components/ResetPasswordForm.vue'
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      ResetPasswordForm,
      PageIntro,
      FooterShout
    }
  }
</script>